module.exports = __webpack_public_path__ + "img/globe-nav-chevron-up-down-grey.bae8d8cb.svg";